import { ConsignmentSettlementDetailPage } from "@/features/consignment-settlement/pages/ConsignmentSettlementDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/consignment-settlement/$id/detail",
)({
	// Deep-link support: open the detail pre-selecting a tab and branch filter
	// (e.g. clicking a branch in the breakdown opens Items filtered, in a new tab).
	validateSearch: (
		search: Record<string, unknown>,
	): { tab?: string; branchID?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
		branchID: typeof search.branchID === "string" ? search.branchID : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentSettlementDetailPage,
});
